export default __webpack_public_path__ + "static/char-s-50-en-44217ac0220ff0f365ef377da2aedfee.png";